/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEmailTemplateMaster = /* GraphQL */ `
  query GetEmailTemplateMaster {
    getEmailTemplateMaster {
      TemplateID
      TemplateName
      ValueID
      FieldName
      __typename
    }
  }
`;
export const getEmailSettings = /* GraphQL */ `
  query GetEmailSettings {
    getEmailSettings {
      Email
      TemplateID
      EmailBody
      SMTP_PORT
      SMTP_HOSTNAME
      UserName
      Password
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const getPaymentSettings = /* GraphQL */ `
  query GetPaymentSettings {
    getPaymentSettings {
      Enable_ItemWiseEntry
      Enable_CreditPeriod
      Enable_CreditLimit
      Enable_AutoPayReminder
      Enable_AutoReminderDays
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($PinCode: String!) {
    getLocation(PinCode: $PinCode) {
      PinCode
      State
      District
      __typename
    }
  }
`;
export const testingFetchData = /* GraphQL */ `
  query TestingFetchData {
    testingFetchData {
      name
      country
      mobile
      city
      state
      address
      __typename
    }
  }
`;
export const listTdsReport = /* GraphQL */ `
  query ListTdsReport($FromDate: Int!, $ToDate: Int!) {
    listTdsReport(FromDate: $FromDate, ToDate: $ToDate) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      FinancialYearID
      __typename
    }
  }
`;
export const getAddressEntity = /* GraphQL */ `
  query GetAddressEntity($ID: Int!) {
    getAddressEntity(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getPartyAddressEntity = /* GraphQL */ `
  query GetPartyAddressEntity($ObjectType: String!, $ObjectID: String!) {
    getPartyAddressEntity(ObjectType: $ObjectType, ObjectID: $ObjectID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const listAddressEntitys = /* GraphQL */ `
  query ListAddressEntitys {
    listAddressEntitys {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCodeTranslation = /* GraphQL */ `
  query GetCodeTranslation($CodeType: String!) {
    getCodeTranslation(CodeType: $CodeType) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      StateCode
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const getCompanyCodeTranslation = /* GraphQL */ `
  query GetCompanyCodeTranslation($CodeType: String!) {
    getCompanyCodeTranslation(CodeType: $CodeType) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const listCodeTranslations = /* GraphQL */ `
  query ListCodeTranslations {
    listCodeTranslations {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      StateCode
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const listCompanyCodeTranslations = /* GraphQL */ `
  query ListCompanyCodeTranslations {
    listCompanyCodeTranslations {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany {
    getCompany {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const getCompanyDetails = /* GraphQL */ `
  query GetCompanyDetails($CompanyID: Int) {
    getCompanyDetails(CompanyID: $CompanyID) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      IndustryTypeCD
      BusinessTypeCD
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      City
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      StatusCode
      StatusMessage
      ActiveFlag
      __typename
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys {
    listCompanys {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const getCompanyBranch = /* GraphQL */ `
  query GetCompanyBranch($ID: Int!) {
    getCompanyBranch(ID: $ID) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      BranchName
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCompanyBranchs = /* GraphQL */ `
  query ListCompanyBranchs {
    listCompanyBranchs {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      BranchName
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCompanyBranchRolePermissions = /* GraphQL */ `
  query GetCompanyBranchRolePermissions($ID: Int!) {
    getCompanyBranchRolePermissions(ID: $ID) {
      ID
      RoleID
      CompanyID
      CompanyBranchID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCompanyBranchRolePermissionss = /* GraphQL */ `
  query ListCompanyBranchRolePermissionss {
    listCompanyBranchRolePermissionss {
      ID
      RoleID
      CompanyID
      CompanyBranchID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCompanyBranchUserRoles = /* GraphQL */ `
  query GetCompanyBranchUserRoles($ID: Int!) {
    getCompanyBranchUserRoles(ID: $ID) {
      ID
      CompanyID
      CompanyBranchID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const listCompanyBranchUserRoless = /* GraphQL */ `
  query ListCompanyBranchUserRoless {
    listCompanyBranchUserRoless {
      ID
      CompanyID
      CompanyBranchID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const getCompanyEntity = /* GraphQL */ `
  query GetCompanyEntity {
    getCompanyEntity {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LegalName
      GSTIN
      FinancialYearCode
      CompanyEntityType
      StartDate
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCompanyEntitys = /* GraphQL */ `
  query ListCompanyEntitys {
    listCompanyEntitys {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LegalName
      GSTIN
      FinancialYearCode
      CompanyEntityType
      StartDate
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCompanyRolePermissionss = /* GraphQL */ `
  query ListCompanyRolePermissionss {
    listCompanyRolePermissionss {
      ID
      RoleID
      CompanyID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getCompanyRoles = /* GraphQL */ `
  query GetCompanyRoles($ID: Int!) {
    getCompanyRoles(ID: $ID) {
      ID
      RoleID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCompanyRoless = /* GraphQL */ `
  query ListCompanyRoless {
    listCompanyRoless {
      ID
      RoleID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCompanyUserRoles = /* GraphQL */ `
  query GetCompanyUserRoles($ID: Int!) {
    getCompanyUserRoles(ID: $ID) {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const listCompanyUserRoless = /* GraphQL */ `
  query ListCompanyUserRoless {
    listCompanyUserRoless {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const getEmailContacts = /* GraphQL */ `
  query GetEmailContacts($ID: Int!) {
    getEmailContacts(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      EmailAddress
      VerifiedDateTime
      PromotionsSignup
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listEmailContactss = /* GraphQL */ `
  query ListEmailContactss {
    listEmailContactss {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      EmailAddress
      VerifiedDateTime
      PromotionsSignup
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const getPermissions = /* GraphQL */ `
  query GetPermissions($ID: Int!) {
    getPermissions(ID: $ID) {
      ID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionName
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPermissionss = /* GraphQL */ `
  query ListPermissionss {
    listPermissionss {
      ID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionName
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPhoneContacts = /* GraphQL */ `
  query GetPhoneContacts($ID: Int!) {
    getPhoneContacts(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      CountryCode
      PhoneNumber
      VerifiedDateTime
      PromotionsSignup
      SMSAllowed
      CallAllowed
      WhatsappAllowed
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPhoneContactss = /* GraphQL */ `
  query ListPhoneContactss {
    listPhoneContactss {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      CountryCode
      PhoneNumber
      VerifiedDateTime
      PromotionsSignup
      SMSAllowed
      CallAllowed
      WhatsappAllowed
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getRolePermissions = /* GraphQL */ `
  query GetRolePermissions($ID: Int!) {
    getRolePermissions(ID: $ID) {
      ID
      PermissionID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listRolePermissionss = /* GraphQL */ `
  query ListRolePermissionss {
    listRolePermissionss {
      ID
      PermissionID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getRoles = /* GraphQL */ `
  query GetRoles($ID: Int!) {
    getRoles(ID: $ID) {
      ID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleName
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listRoless = /* GraphQL */ `
  query ListRoless {
    listRoless {
      ID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleName
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($ID: Int!) {
    getUserInfo(ID: $ID) {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos {
    listUserInfos {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const getItemmaster = /* GraphQL */ `
  query GetItemmaster($ItemID: Int!) {
    getItemmaster(ItemID: $ItemID) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Description
      __typename
    }
  }
`;
export const listItemmasters = /* GraphQL */ `
  query ListItemmasters {
    listItemmasters {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Description
      __typename
    }
  }
`;
export const listItemmastersv2 = /* GraphQL */ `
  query ListItemmastersv2(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listItemmastersv2(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      LastUpdatedBy
      ItemAmountEnteredTimeStamp
      ItemAmountExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      ItemAmountHSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      DiscountType
      DiscountValue
      ImageName
      ImageURL
      SerialNumber
      IsDefault
      InvoiceType
      DefaultSellingPrice
      DefaultPurchasePrice
      CodeText
      ItemCategory
      SellingGSTCompensationType
      PurchaseGSTCompensationType
      SellingGSTCompensationValue
      PurchaseGSTCompensationValue
      SellingGSTRATE
      PurchaseGSTRATE
      SellingDiscountType
      PurchaseDiscountType
      SellingDiscountValue
      PurchaseDiscountValue
      Description
      __typename
    }
  }
`;
export const listItemmastersv2Count = /* GraphQL */ `
  query ListItemmastersv2Count(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listItemmastersv2Count(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      ItemCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPartyMaster = /* GraphQL */ `
  query GetPartyMaster($PartyID: Int!) {
    getPartyMaster(PartyID: $PartyID) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const getPartyMasterAccountWise = /* GraphQL */ `
  query GetPartyMasterAccountWise($AccountsID: Int!) {
    getPartyMasterAccountWise(AccountsID: $AccountsID) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      relatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      __typename
    }
  }
`;
export const listPartymasters = /* GraphQL */ `
  query ListPartymasters {
    listPartymasters {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const listPartymastersv2 = /* GraphQL */ `
  query ListPartymastersv2(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPartymastersv2(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      PartyGSTEnteredTimeStamp
      PartyGSTExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      ContactTypeName
      ContactDesignationName
      ContactOrder
      PartyContactEmail
      PhoneNumber
      PartyContactWhatsappNumber
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      SameAddressFlag
      Comments
      AccountBalance
      TDSSection
      __typename
    }
  }
`;
export const listPartymastersv2Count = /* GraphQL */ `
  query ListPartymastersv2Count(
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPartymastersv2Count(
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PartyCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getItemCategorymaster = /* GraphQL */ `
  query GetItemCategorymaster($ItemCategoryID: Int!) {
    getItemCategorymaster(ItemCategoryID: $ItemCategoryID) {
      ItemCategoryID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Category
      ItemCategoryGroupID
      MainCategory
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listItemCategorymaster = /* GraphQL */ `
  query ListItemCategorymaster($MainCategory: String!) {
    listItemCategorymaster(MainCategory: $MainCategory) {
      ItemCategoryID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Category
      ItemCategoryGroupID
      MainCategory
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const getHSNSACmaster = /* GraphQL */ `
  query GetHSNSACmaster($HSNSACID: Int!) {
    getHSNSACmaster(HSNSACID: $HSNSACID) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const listHSNSACmaster = /* GraphQL */ `
  query ListHSNSACmaster {
    listHSNSACmaster {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const listHSN = /* GraphQL */ `
  query ListHSN($RowFrom: Int!, $LimitNo: Int!) {
    listHSN(RowFrom: $RowFrom, LimitNo: $LimitNo) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const searchHSN = /* GraphQL */ `
  query SearchHSN($RowFrom: Int!, $LimitNo: Int!, $Word: String!) {
    searchHSN(RowFrom: $RowFrom, LimitNo: $LimitNo, Word: $Word) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const searchSAC = /* GraphQL */ `
  query SearchSAC($RowFrom: Int!, $LimitNo: Int!, $Word: String!) {
    searchSAC(RowFrom: $RowFrom, LimitNo: $LimitNo, Word: $Word) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const listSAC = /* GraphQL */ `
  query ListSAC {
    listSAC {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const getPartyContact = /* GraphQL */ `
  query GetPartyContact($PartyID: Int!) {
    getPartyContact(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ContactTypeName
      ContactDesignationName
      ContactOrder
      Email
      PhoneNumber
      WhatsappNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPartyCreditDetails = /* GraphQL */ `
  query GetPartyCreditDetails($PartyID: Int!) {
    getPartyCreditDetails(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPartyGSTDetails = /* GraphQL */ `
  query GetPartyGSTDetails($PartyID: Int!) {
    getPartyGSTDetails(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPartyContact = /* GraphQL */ `
  query ListPartyContact {
    listPartyContact {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ContactTypeName
      ContactDesignationName
      ContactOrder
      Email
      PhoneNumber
      WhatsappNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPartyCreditDetails = /* GraphQL */ `
  query ListPartyCreditDetails {
    listPartyCreditDetails {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPartyGSTDetails = /* GraphQL */ `
  query ListPartyGSTDetails {
    listPartyGSTDetails {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getInvoiceMaster = /* GraphQL */ `
  query GetInvoiceMaster($InvoiceID: Int!) {
    getInvoiceMaster(InvoiceID: $InvoiceID) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listInvoiceMaster = /* GraphQL */ `
  query ListInvoiceMaster {
    listInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listInvoiceMastervr2 = /* GraphQL */ `
  query ListInvoiceMastervr2 {
    listInvoiceMastervr2 {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      __typename
    }
  }
`;
export const listOutstandingInvoiceMaster = /* GraphQL */ `
  query ListOutstandingInvoiceMaster {
    listOutstandingInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listInvoiceMasterRange = /* GraphQL */ `
  query ListInvoiceMasterRange($StartDate: Int!, $EndDate: Int!) {
    listInvoiceMasterRange(StartDate: $StartDate, EndDate: $EndDate) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const getInvoiceNumberTracker = /* GraphQL */ `
  query GetInvoiceNumberTracker($CompanyID: Int!) {
    getInvoiceNumberTracker(CompanyID: $CompanyID) {
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      NextInvoiceNumber
      LastUpdatedBy
      __typename
    }
  }
`;
export const listInvoiceNumberTracker = /* GraphQL */ `
  query ListInvoiceNumberTracker {
    listInvoiceNumberTracker {
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      NextInvoiceNumber
      LastUpdatedBy
      __typename
    }
  }
`;
export const getInvoiceAttachment = /* GraphQL */ `
  query GetInvoiceAttachment($InvoiceID: Int!) {
    getInvoiceAttachment(InvoiceID: $InvoiceID) {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const listInvoiceAttachment = /* GraphQL */ `
  query ListInvoiceAttachment {
    listInvoiceAttachment {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const getInvoiceLineItems = /* GraphQL */ `
  query GetInvoiceLineItems($InvoiceID: Int!) {
    getInvoiceLineItems(InvoiceID: $InvoiceID) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      Unit
      UQC
      SalesAccountName
      SalesAccountID
      __typename
    }
  }
`;
export const listInvoiceLineItems = /* GraphQL */ `
  query ListInvoiceLineItems {
    listInvoiceLineItems {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      Unit
      UQC
      SalesAccountName
      SalesAccountID
      __typename
    }
  }
`;
export const getInvoiceDispatch = /* GraphQL */ `
  query GetInvoiceDispatch($InvoiceID: Int!) {
    getInvoiceDispatch(InvoiceID: $InvoiceID) {
      InvoiceID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listInvoiceDispatch = /* GraphQL */ `
  query ListInvoiceDispatch {
    listInvoiceDispatch {
      InvoiceID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getInvoiceLineGST = /* GraphQL */ `
  query GetInvoiceLineGST($InvoiceID: Int!) {
    getInvoiceLineGST(InvoiceID: $InvoiceID) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listInvoiceLineGST = /* GraphQL */ `
  query ListInvoiceLineGST {
    listInvoiceLineGST {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getInvoiceLineNonItems = /* GraphQL */ `
  query GetInvoiceLineNonItems($InvoiceID: Int!) {
    getInvoiceLineNonItems(InvoiceID: $InvoiceID) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceLineItemType
      IncomeAccountID
      HSNSACCode
      Taxability
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      IncomeAccountName
      __typename
    }
  }
`;
export const listInvoiceLineNonItems = /* GraphQL */ `
  query ListInvoiceLineNonItems {
    listInvoiceLineNonItems {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceLineItemType
      IncomeAccountID
      HSNSACCode
      Taxability
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      IncomeAccountName
      __typename
    }
  }
`;
export const getInvoicePOSDetails = /* GraphQL */ `
  query GetInvoicePOSDetails($POSID: Int!) {
    getInvoicePOSDetails(POSID: $POSID) {
      POSID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyPOSID
      LastUpdatedBy
      RelatedPOSParty {
        PosPartyID
        CompanyID
        PartyName
        PartyContactNumberID
        LastUpdatedBy
        EnteredTimeStamp
        ExpiredTimeStamp
        RelatedPhoneContacts {
          ID
          ObjectType
          ObjectID
          EnteredTimeStamp
          ExpiredTimeStamp
          CountryCode
          PhoneNumber
          VerifiedDateTime
          PromotionsSignup
          SMSAllowed
          CallAllowed
          WhatsappAllowed
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        __typename
      }
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listInvoicePOSDetails = /* GraphQL */ `
  query ListInvoicePOSDetails {
    listInvoicePOSDetails {
      POSID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyPOSID
      LastUpdatedBy
      RelatedPOSParty {
        PosPartyID
        CompanyID
        PartyName
        PartyContactNumberID
        LastUpdatedBy
        EnteredTimeStamp
        ExpiredTimeStamp
        RelatedPhoneContacts {
          ID
          ObjectType
          ObjectID
          EnteredTimeStamp
          ExpiredTimeStamp
          CountryCode
          PhoneNumber
          VerifiedDateTime
          PromotionsSignup
          SMSAllowed
          CallAllowed
          WhatsappAllowed
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        __typename
      }
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getItemImages = /* GraphQL */ `
  query GetItemImages($ItemID: Int!) {
    getItemImages(ItemID: $ItemID) {
      AttachmentID
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      DocumentName
      Type
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listItemImages = /* GraphQL */ `
  query ListItemImages {
    listItemImages {
      AttachmentID
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      DocumentName
      Type
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPartyImages = /* GraphQL */ `
  query GetPartyImages($PartyID: Int!) {
    getPartyImages(PartyID: $PartyID) {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPartyImages = /* GraphQL */ `
  query ListPartyImages {
    listPartyImages {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPurchaseAttachment = /* GraphQL */ `
  query GetPurchaseAttachment($PurchaseID: Int!) {
    getPurchaseAttachment(PurchaseID: $PurchaseID) {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const listPurchaseAttachment = /* GraphQL */ `
  query ListPurchaseAttachment {
    listPurchaseAttachment {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const getPurchaseLineGST = /* GraphQL */ `
  query GetPurchaseLineGST($PurchaseID: Int!) {
    getPurchaseLineGST(PurchaseID: $PurchaseID) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPurchaseLineGST = /* GraphQL */ `
  query ListPurchaseLineGST {
    listPurchaseLineGST {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getPurchaseLineItems = /* GraphQL */ `
  query GetPurchaseLineItems($PurchaseID: Int!) {
    getPurchaseLineItems(PurchaseID: $PurchaseID) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNSACCode
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      Unit
      UQC
      PurchaseAccountName
      __typename
    }
  }
`;
export const listPurchaseLineItems = /* GraphQL */ `
  query ListPurchaseLineItems {
    listPurchaseLineItems {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNSACCode
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      Unit
      UQC
      PurchaseAccountName
      __typename
    }
  }
`;
export const getPurchaseMaster = /* GraphQL */ `
  query GetPurchaseMaster($PurchaseID: Int!) {
    getPurchaseMaster(PurchaseID: $PurchaseID) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPurchaseMaster = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPurchaseMasterv2 = /* GraphQL */ `
  query ListPurchaseMasterv2 {
    listPurchaseMasterv2 {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyAccountID
      ReverseChargeFlag
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPurchaseMasterTest = /* GraphQL */ `
  query ListPurchaseMasterTest(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPurchaseMasterTest(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPurchaseMasterCount = /* GraphQL */ `
  query ListPurchaseMasterCount(
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPurchaseMasterCount(
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PurchaseMasterListCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listInvoiceMasterv2 = /* GraphQL */ `
  query ListInvoiceMasterv2(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listInvoiceMasterv2(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listInvoiceMasterCount = /* GraphQL */ `
  query ListInvoiceMasterCount(
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listInvoiceMasterCount(
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      InvoiceMasterListCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listOutstandingPurchaseMaster = /* GraphQL */ `
  query ListOutstandingPurchaseMaster {
    listOutstandingPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPurchaseMasterRange = /* GraphQL */ `
  query ListPurchaseMasterRange($StartDate: Int!, $EndDate: Int!) {
    listPurchaseMasterRange(StartDate: $StartDate, EndDate: $EndDate) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const getPurchaseTDSDetails = /* GraphQL */ `
  query GetPurchaseTDSDetails($PurchaseID: Int!) {
    getPurchaseTDSDetails(PurchaseID: $PurchaseID) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPurchaseTDSDetails = /* GraphQL */ `
  query ListPurchaseTDSDetails {
    listPurchaseTDSDetails {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listPurchaseTDSDetailsv2 = /* GraphQL */ `
  query ListPurchaseTDSDetailsv2 {
    listPurchaseTDSDetailsv2 {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      LastUpdatedBy
      StatusCode
      StatusMessage
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      PartyDisplayName
      PANNummber
      CodeValue
      CodeText
      CodeOrder
      __typename
    }
  }
`;
export const listPurchaseTDSDetailsv3 = /* GraphQL */ `
  query ListPurchaseTDSDetailsv3(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPurchaseTDSDetailsv3(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      LastUpdatedBy
      StatusCode
      StatusMessage
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      PartyDisplayName
      PANNummber
      CodeValue
      CodeText
      CodeOrder
      __typename
    }
  }
`;
export const getPurchaseLineNonItems = /* GraphQL */ `
  query GetPurchaseLineNonItems($PurchaseID: Int!) {
    getPurchaseLineNonItems(PurchaseID: $PurchaseID) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseLineItemType
      PurchaseAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      PurchaseAccountName
      __typename
    }
  }
`;
export const listPurchaseLineNonItems = /* GraphQL */ `
  query ListPurchaseLineNonItems {
    listPurchaseLineNonItems {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseLineItemType
      PurchaseAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      PurchaseAccountName
      __typename
    }
  }
`;
export const getTransactionAttachment = /* GraphQL */ `
  query GetTransactionAttachment($TransactionID: Int!) {
    getTransactionAttachment(TransactionID: $TransactionID) {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const listTransactionAttachment = /* GraphQL */ `
  query ListTransactionAttachment {
    listTransactionAttachment {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const getTransactionDetails = /* GraphQL */ `
  query GetTransactionDetails($TransactionID: Int!) {
    getTransactionDetails(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      FinancialYearID
      __typename
    }
  }
`;
export const listTransactionDetails = /* GraphQL */ `
  query ListTransactionDetails {
    listTransactionDetails {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      FinancialYearID
      __typename
    }
  }
`;
export const listTransactionDetailsNew = /* GraphQL */ `
  query ListTransactionDetailsNew(
    $RowFrom: Int!
    $LimitNo: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listTransactionDetailsNew(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      FinancialYearID
      __typename
    }
  }
`;
export const getTransactionMaster = /* GraphQL */ `
  query GetTransactionMaster($TransactionID: Int!) {
    getTransactionMaster(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const listTransactionMaster = /* GraphQL */ `
  query ListTransactionMaster {
    listTransactionMaster {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const listTransactionMasterv2 = /* GraphQL */ `
  query ListTransactionMasterv2(
    $TransactionTypeCD: String
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listTransactionMasterv2(
      TransactionTypeCD: $TransactionTypeCD
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      PaidFrom
      PaidTo
      PaidFromAmount
      PaidToAmount
      PaidFromAccountID
      PaidToAccountID
      PaidFromEmail
      PaidToEmail
      PaidFromPartyID
      PaidToPartyID
      PaidFromPartyTypeCD
      PaidToPartyTypeCD
      __typename
    }
  }
`;
export const listTransactionMasterCount = /* GraphQL */ `
  query ListTransactionMasterCount(
    $TransactionTypeCD: String
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listTransactionMasterCount(
      TransactionTypeCD: $TransactionTypeCD
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      TransactionMasterListCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listTransactionType = /* GraphQL */ `
  query ListTransactionType {
    listTransactionType {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const listPaymentsTransactionType = /* GraphQL */ `
  query ListPaymentsTransactionType {
    listPaymentsTransactionType {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const listReceiptsTransactionType = /* GraphQL */ `
  query ListReceiptsTransactionType {
    listReceiptsTransactionType {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const listTransactionManualJournal = /* GraphQL */ `
  query ListTransactionManualJournal {
    listTransactionManualJournal {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const getTransactionTDSDetails = /* GraphQL */ `
  query GetTransactionTDSDetails($TransactionID: Int!) {
    getTransactionTDSDetails(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TDSAmount
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TDSPercentage
      __typename
    }
  }
`;
export const listTransactionTDSDetails = /* GraphQL */ `
  query ListTransactionTDSDetails {
    listTransactionTDSDetails {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TDSAmount
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TDSPercentage
      __typename
    }
  }
`;
export const getAccountMaster = /* GraphQL */ `
  query GetAccountMaster($AccountsID: Int!) {
    getAccountMaster(AccountsID: $AccountsID) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listAccountMaster = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listAccountMasterv2 = /* GraphQL */ `
  query ListAccountMasterv2 {
    listAccountMasterv2 {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountGroupEnteredTimeStamp
      AccountGroupExpiredTimeStamp
      AccountGroupTypeCD
      AccountGroupName
      AccountParentGroupID
      AccountGroupDisplayOrderNumber
      AccountGroupRestrictedflag
      AccountGroupIs_Active
      AccountGSTEnteredTimeStamp
      AccountGSTExpiredTimeStamp
      AccountGSTEffectiveDate
      AccountGSTExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      AccountTypeFlag
      PartyID
      TDSPercentage
      TDSSection
      path
      __typename
    }
  }
`;
export const listAccountMasterSearch = /* GraphQL */ `
  query ListAccountMasterSearch($Word: String!) {
    listAccountMasterSearch(Word: $Word) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountGroupEnteredTimeStamp
      AccountGroupExpiredTimeStamp
      AccountGroupTypeCD
      AccountGroupName
      AccountParentGroupID
      AccountGroupDisplayOrderNumber
      AccountGroupRestrictedflag
      AccountGroupIs_Active
      AccountGSTEnteredTimeStamp
      AccountGSTExpiredTimeStamp
      AccountGSTEffectiveDate
      AccountGSTExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      AccountTypeFlag
      PartyID
      TDSPercentage
      TDSSection
      path
      __typename
    }
  }
`;
export const getAccountGroupMaster = /* GraphQL */ `
  query GetAccountGroupMaster($AccountGroupID: Int!) {
    getAccountGroupMaster(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listAccountGroupMaster = /* GraphQL */ `
  query ListAccountGroupMaster {
    listAccountGroupMaster {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listAccountGroupMasterv2 = /* GraphQL */ `
  query ListAccountGroupMasterv2 {
    listAccountGroupMasterv2 {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      __typename
    }
  }
`;
export const getAccountGSTDetails = /* GraphQL */ `
  query GetAccountGSTDetails($AccountID: Int!) {
    getAccountGSTDetails(AccountID: $AccountID) {
      AccountID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listAccountGSTDetails = /* GraphQL */ `
  query ListAccountGSTDetails {
    listAccountGSTDetails {
      AccountID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getAccountOpeningBalance = /* GraphQL */ `
  query GetAccountOpeningBalance($AccountsID: Int!) {
    getAccountOpeningBalance(AccountsID: $AccountsID) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      StartDate
      CreditAmount
      DebitAmount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listAccountOpeningBalance = /* GraphQL */ `
  query ListAccountOpeningBalance {
    listAccountOpeningBalance {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      StartDate
      CreditAmount
      DebitAmount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getFinancialYear = /* GraphQL */ `
  query GetFinancialYear($FinancialYearID: Int!) {
    getFinancialYear(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const getUserPreference = /* GraphQL */ `
  query GetUserPreference($FinancialYearID: Int!) {
    getUserPreference(FinancialYearID: $FinancialYearID) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const getSideBarUserPreference = /* GraphQL */ `
  query GetSideBarUserPreference($FinancialYearID: Int!) {
    getSideBarUserPreference(FinancialYearID: $FinancialYearID) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const getUserThemePreference = /* GraphQL */ `
  query GetUserThemePreference {
    getUserThemePreference {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      RelatedThemeColor {
        ThemeID
        Color
        EnteredTimeStamp
        ExpiredTimeStamp
        __typename
      }
      __typename
    }
  }
`;
export const listUserPreference = /* GraphQL */ `
  query ListUserPreference {
    listUserPreference {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const listFinancialYear = /* GraphQL */ `
  query ListFinancialYear {
    listFinancialYear {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const listFinancialYearTransferHistory = /* GraphQL */ `
  query ListFinancialYearTransferHistory {
    listFinancialYearTransferHistory {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearIDFrom
      FinancialYearIDTo
      TransferDate
      __typename
    }
  }
`;
export const listAllFinancialYears = /* GraphQL */ `
  query ListAllFinancialYears {
    listAllFinancialYears {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const listThemeColors = /* GraphQL */ `
  query ListThemeColors {
    listThemeColors {
      ThemeID
      Color
      EnteredTimeStamp
      ExpiredTimeStamp
      __typename
    }
  }
`;
export const getAccountBalance = /* GraphQL */ `
  query GetAccountBalance($AccountID: Int!) {
    getAccountBalance(AccountID: $AccountID) {
      AccountID
      AccountBalance
      ActualBalance
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listProfitAndLoss = /* GraphQL */ `
  query ListProfitAndLoss {
    listProfitAndLoss {
      CompanyID
      CompanyBranchID
      AccountsID
      AccountTypeCD
      AccountName
      GroupOrderNumber
      AccountGroupID
      AccountGroupName
      Debit
      Credit
      BalanceAmount
      FinancialYearID
      StartDate
      EndDate
      EnteredTimeStamp
      ExpiredTimeStamp
      TypeCD
      Restrictedflag
      __typename
    }
  }
`;
export const listPartyInvoices = /* GraphQL */ `
  query ListPartyInvoices($PartyID: Int!) {
    listPartyInvoices(PartyID: $PartyID) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listPartyPurchases = /* GraphQL */ `
  query ListPartyPurchases($SupplierID: Int!) {
    listPartyPurchases(SupplierID: $SupplierID) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listTrialbalance = /* GraphQL */ `
  query ListTrialbalance {
    listTrialbalance {
      CompanyID
      CompanyBranchID
      AccountsID
      AccountTypeCD
      AccountName
      DisplayOrderNumber
      AccountGroupID
      AccountGroupName
      GroupOrderNumber
      Credit
      Debit
      BalanceAmount
      FinancialYearID
      StartDate
      EndDate
      EnteredTimeStamp
      ExpiredTimeStamp
      TypeCD
      Restrictedflag
      __typename
    }
  }
`;
export const listBalancesheet = /* GraphQL */ `
  query ListBalancesheet {
    listBalancesheet {
      CompanyID
      CompanyBranchID
      AccountsID
      AccountTypeCD
      AccountName
      AccountGroupID
      AccountGroupName
      GroupOrderNumber
      Credit
      Debit
      BalanceAmount
      TypeCD
      Restrictedflag
      __typename
    }
  }
`;
export const getCrDrNoteMaster = /* GraphQL */ `
  query GetCrDrNoteMaster($CrDrNoteID: Int!) {
    getCrDrNoteMaster(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const listCrDrNoteMaster = /* GraphQL */ `
  query ListCrDrNoteMaster {
    listCrDrNoteMaster {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const listCrDrNoteMasterv2 = /* GraphQL */ `
  query ListCrDrNoteMasterv2(
    $CrDrNoteTypeCD: String!
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listCrDrNoteMasterv2(
      CrDrNoteTypeCD: $CrDrNoteTypeCD
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      PartyAccountID
      PartyTypeCd
      OriginalInvoiceNumber
      PartyInvoiceNumber
      PaymentStatus
      __typename
    }
  }
`;
export const listCrDrNoteMasterCount = /* GraphQL */ `
  query ListCrDrNoteMasterCount(
    $CrDrNoteTypeCD: String!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listCrDrNoteMasterCount(
      CrDrNoteTypeCD: $CrDrNoteTypeCD
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      CrDrNoteMasterListCount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getCrDrNoteInvoices = /* GraphQL */ `
  query GetCrDrNoteInvoices($CrDrNoteID: Int!) {
    getCrDrNoteInvoices(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceID
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const listCrDrNoteInvoices = /* GraphQL */ `
  query ListCrDrNoteInvoices {
    listCrDrNoteInvoices {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceID
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCrDrAttachment = /* GraphQL */ `
  query GetCrDrAttachment($CrDrNoteID: Int!) {
    getCrDrAttachment(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const listCrDrAttachment = /* GraphQL */ `
  query ListCrDrAttachment {
    listCrDrAttachment {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const getCrDrNoteDetails = /* GraphQL */ `
  query GetCrDrNoteDetails($CrDrNoteID: Int!) {
    getCrDrNoteDetails(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TotalTaxableAmount
      TotalGST
      TotalGSTCess
      TotalAdjustments
      Comments
      AccountID
      PartAmount
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listCrDrNoteDetails = /* GraphQL */ `
  query ListCrDrNoteDetails {
    listCrDrNoteDetails {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TotalTaxableAmount
      TotalGST
      TotalGSTCess
      TotalAdjustments
      Comments
      AccountID
      PartAmount
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getCrDrNoteLineItems = /* GraphQL */ `
  query GetCrDrNoteLineItems($CrDrNoteID: Int!) {
    getCrDrNoteLineItems(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      LineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      HSNSACCode
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      PriceType
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Unit
      UQC
      SalesAccountName
      PurchaseAccountName
      SalesAccountID
      PurchaseAccountID
      __typename
    }
  }
`;
export const listCrDrNoteLineItems = /* GraphQL */ `
  query ListCrDrNoteLineItems {
    listCrDrNoteLineItems {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      LineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      HSNSACCode
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      PriceType
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Unit
      UQC
      SalesAccountName
      PurchaseAccountName
      SalesAccountID
      PurchaseAccountID
      __typename
    }
  }
`;
export const getCrDrNoteLineNonItems = /* GraphQL */ `
  query GetCrDrNoteLineNonItems($CrDrNoteID: Int!) {
    getCrDrNoteLineNonItems(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemType
      LedgerAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      LedgerAccountName
      __typename
    }
  }
`;
export const listCrDrNoteLineNonItems = /* GraphQL */ `
  query ListCrDrNoteLineNonItems {
    listCrDrNoteLineNonItems {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemType
      LedgerAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      LedgerAccountName
      __typename
    }
  }
`;
export const listCashAccounts = /* GraphQL */ `
  query ListCashAccounts {
    listCashAccounts {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listBankAccounts = /* GraphQL */ `
  query ListBankAccounts {
    listBankAccounts {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listAccountTransactionDetails = /* GraphQL */ `
  query ListAccountTransactionDetails(
    $AccountID: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listAccountTransactionDetails(
      AccountID: $AccountID
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      RelatedAccountsTransaction {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        VoucherNumber
        TransactionMasterTypeCD
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        FinancialYearID
        __typename
      }
      LastUpdatedBy
      FinancialYearID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listAccountTransactionsCount = /* GraphQL */ `
  query ListAccountTransactionsCount(
    $AccountID: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listAccountTransactionsCount(
      AccountID: $AccountID
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionCount
      __typename
    }
  }
`;
export const listAccountRelatedTransactionsCount = /* GraphQL */ `
  query ListAccountRelatedTransactionsCount(
    $AccountID: Int!
    $TransactionID: Int!
    $TransactionTypeCD: String
  ) {
    listAccountRelatedTransactionsCount(
      AccountID: $AccountID
      TransactionID: $TransactionID
      TransactionTypeCD: $TransactionTypeCD
    ) {
      TransactionCount
      __typename
    }
  }
`;
export const listDayBookTransactionDetails = /* GraphQL */ `
  query ListDayBookTransactionDetails($StartDate: Int!, $EndDate: Int!) {
    listDayBookTransactionDetails(StartDate: $StartDate, EndDate: $EndDate) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      VoucherNumber
      TransactionMasterTypeCD
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      FinancialYearID
      __typename
    }
  }
`;
export const listDayBookTransactionsCount = /* GraphQL */ `
  query ListDayBookTransactionsCount($StartDate: Int!, $EndDate: Int!) {
    listDayBookTransactionsCount(StartDate: $StartDate, EndDate: $EndDate) {
      TransactionCount
      __typename
    }
  }
`;
export const listCashTransactionDetails = /* GraphQL */ `
  query ListCashTransactionDetails(
    $RowFrom: Int!
    $LimitNo: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listCashTransactionDetails(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      RelatedAccountsTransaction {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        VoucherNumber
        TransactionMasterTypeCD
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        FinancialYearID
        __typename
      }
      LastUpdatedBy
      FinancialYearID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listBankTransactionDetails = /* GraphQL */ `
  query ListBankTransactionDetails(
    $RowFrom: Int!
    $LimitNo: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listBankTransactionDetails(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      RelatedAccountsTransaction {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        VoucherNumber
        TransactionMasterTypeCD
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        FinancialYearID
        __typename
      }
      LastUpdatedBy
      FinancialYearID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listAccountGroupAccountsTransaction = /* GraphQL */ `
  query ListAccountGroupAccountsTransaction(
    $AccountGroupID: Int!
    $StartDate: Int!
  ) {
    listAccountGroupAccountsTransaction(
      AccountGroupID: $AccountGroupID
      StartDate: $StartDate
    ) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      StartDate
      FinancialYearID
      TransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        RelatedAccountsTransaction {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          VoucherNumber
          TransactionMasterTypeCD
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          FinancialYearID
          __typename
        }
        FinancialYearID
        __typename
      }
      __typename
    }
  }
`;
export const getDebitBillingAddress = /* GraphQL */ `
  query GetDebitBillingAddress($CrDrNoteID: Int!) {
    getDebitBillingAddress(CrDrNoteID: $CrDrNoteID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getDebitDeliveryAddress = /* GraphQL */ `
  query GetDebitDeliveryAddress($CrDrNoteID: Int!) {
    getDebitDeliveryAddress(CrDrNoteID: $CrDrNoteID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCreditBillingAddress = /* GraphQL */ `
  query GetCreditBillingAddress($CrDrNoteID: Int!) {
    getCreditBillingAddress(CrDrNoteID: $CrDrNoteID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getCreditDeliveryAddress = /* GraphQL */ `
  query GetCreditDeliveryAddress($CrDrNoteID: Int!) {
    getCreditDeliveryAddress(CrDrNoteID: $CrDrNoteID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getSalesBillingAddress = /* GraphQL */ `
  query GetSalesBillingAddress($InvoiceNumber: String!) {
    getSalesBillingAddress(InvoiceNumber: $InvoiceNumber) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const getSalesDeliveryAddress = /* GraphQL */ `
  query GetSalesDeliveryAddress($InvoiceNumber: String!) {
    getSalesDeliveryAddress(InvoiceNumber: $InvoiceNumber) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const listExternalAPIDetails = /* GraphQL */ `
  query ListExternalAPIDetails {
    listExternalAPIDetails {
      RequestCode
      __typename
    }
  }
`;
export const getBankDetails = /* GraphQL */ `
  query GetBankDetails($ObjectID: String!, $ObjectType: String!) {
    getBankDetails(ObjectID: $ObjectID, ObjectType: $ObjectType) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getBankDetailsByAccountName = /* GraphQL */ `
  query GetBankDetailsByAccountName($AccountName: String!) {
    getBankDetailsByAccountName(AccountName: $AccountName) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listBankDetails = /* GraphQL */ `
  query ListBankDetails {
    listBankDetails {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listFinancialYearStatus = /* GraphQL */ `
  query ListFinancialYearStatus {
    listFinancialYearStatus {
      FinancialYearID
      StatusTypeCD
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusValue
      UserID
      __typename
    }
  }
`;
export const getFinancialYearStatus = /* GraphQL */ `
  query GetFinancialYearStatus($FinancialYearID: Int!) {
    getFinancialYearStatus(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      StatusTypeCD
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusValue
      UserID
      __typename
    }
  }
`;
export const listAccountTransactionExtraDetails = /* GraphQL */ `
  query ListAccountTransactionExtraDetails(
    $TransactionTypeCD1: String!
    $TransactionTypeCD2: String!
    $AccountID: Int!
  ) {
    listAccountTransactionExtraDetails(
      TransactionTypeCD1: $TransactionTypeCD1
      TransactionTypeCD2: $TransactionTypeCD2
      AccountID: $AccountID
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      TransactionTypeMaster
      VoucherNumber
      EntryDate
      BankReferenceNumber
      MasterComments
      AccountBalance
      __typename
    }
  }
`;
export const listAccountTransactionLinkDetails = /* GraphQL */ `
  query ListAccountTransactionLinkDetails(
    $TransactionTypeCD1: String!
    $TransactionTypeCD2: String!
    $TransactiondetailsTypeCD: String!
    $AccountID: Int!
  ) {
    listAccountTransactionLinkDetails(
      TransactionTypeCD1: $TransactionTypeCD1
      TransactionTypeCD2: $TransactionTypeCD2
      TransactiondetailsTypeCD: $TransactiondetailsTypeCD
      AccountID: $AccountID
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      TransactionTypeMaster
      VoucherNumber
      EntryDate
      BankReferenceNumber
      MasterComments
      AccountBalance
      __typename
    }
  }
`;
export const listProfileCompletion = /* GraphQL */ `
  query ListProfileCompletion {
    listProfileCompletion {
      CompletionPercentage
      __typename
    }
  }
`;
export const listTransactionRelation = /* GraphQL */ `
  query ListTransactionRelation {
    listTransactionRelation {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getTransactionRelation = /* GraphQL */ `
  query GetTransactionRelation($ObjectID: Int!) {
    getTransactionRelation(ObjectID: $ObjectID) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getTransactionRelationWithAccountID = /* GraphQL */ `
  query GetTransactionRelationWithAccountID($AccountID: Int!) {
    getTransactionRelationWithAccountID(AccountID: $AccountID) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getAccountBalanceTill = /* GraphQL */ `
  query GetAccountBalanceTill($AccountID: Int!, $EndDate: Int!) {
    getAccountBalanceTill(AccountID: $AccountID, EndDate: $EndDate) {
      AccountID
      AccountBalance
      __typename
    }
  }
`;
export const listUserCompany = /* GraphQL */ `
  query ListUserCompany {
    listUserCompany {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const listRelatedPaymentTransactionID = /* GraphQL */ `
  query ListRelatedPaymentTransactionID($ObjectID: Int!) {
    listRelatedPaymentTransactionID(ObjectID: $ObjectID) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listGeneralSetting = /* GraphQL */ `
  query ListGeneralSetting($EntryTypeCD: String!, $FinancialYearID: Int) {
    listGeneralSetting(
      EntryTypeCD: $EntryTypeCD
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listVoucherSerialNumbers = /* GraphQL */ `
  query ListVoucherSerialNumbers($EntryTypeCD: String!) {
    listVoucherSerialNumbers(EntryTypeCD: $EntryTypeCD) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listUsedVoucherSerialNumbers = /* GraphQL */ `
  query ListUsedVoucherSerialNumbers($EntryTypeCD: String!) {
    listUsedVoucherSerialNumbers(EntryTypeCD: $EntryTypeCD) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listGeneralSettingDateWise = /* GraphQL */ `
  query ListGeneralSettingDateWise($EntryTypeCD: String!, $InputDate: Int!) {
    listGeneralSettingDateWise(
      EntryTypeCD: $EntryTypeCD
      InputDate: $InputDate
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listAllGeneralSettings = /* GraphQL */ `
  query ListAllGeneralSettings {
    listAllGeneralSettings {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getClosingStock = /* GraphQL */ `
  query GetClosingStock($Date: String!) {
    getClosingStock(Date: $Date) {
      CompanyID
      CompanyBranchID
      Date
      ClosingBalance
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const listInvoiceDenominations = /* GraphQL */ `
  query ListInvoiceDenominations($InvoiceID: Int) {
    listInvoiceDenominations(InvoiceID: $InvoiceID) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Denomination
      Number_Of_Notes
      TypeCD
      Last_Updated_By
      __typename
    }
  }
`;
export const listItemDropdown = /* GraphQL */ `
  query ListItemDropdown($RowFrom: Int!, $LimitNo: Int!, $Word: String!) {
    listItemDropdown(RowFrom: $RowFrom, LimitNo: $LimitNo, Word: $Word) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Description
      __typename
    }
  }
`;
export const listPartyDropdown = /* GraphQL */ `
  query ListPartyDropdown($RowFrom: Int!, $LimitNo: Int!, $Word: String!) {
    listPartyDropdown(RowFrom: $RowFrom, LimitNo: $LimitNo, Word: $Word) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const listAccountsDropdown = /* GraphQL */ `
  query ListAccountsDropdown($RowFrom: Int!, $LimitNo: Int!, $Word: String!) {
    listAccountsDropdown(RowFrom: $RowFrom, LimitNo: $LimitNo, Word: $Word) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listAccountGroupsDropdown = /* GraphQL */ `
  query ListAccountGroupsDropdown(
    $RowFrom: Int!
    $LimitNo: Int!
    $Word: String!
  ) {
    listAccountGroupsDropdown(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      Word: $Word
    ) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listUserPreferenceByType = /* GraphQL */ `
  query ListUserPreferenceByType($AttributeTypeCD: String!) {
    listUserPreferenceByType(AttributeTypeCD: $AttributeTypeCD) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const listDeletedInvoices = /* GraphQL */ `
  query ListDeletedInvoices {
    listDeletedInvoices {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      __typename
    }
  }
`;
export const listDeletedPurchases = /* GraphQL */ `
  query ListDeletedPurchases {
    listDeletedPurchases {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      SerialNumber
      CurrencyCode
      CurrencyRate
      ReverseChargeFlag
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listDeletedPayments = /* GraphQL */ `
  query ListDeletedPayments($Type: String!) {
    listDeletedPayments(Type: $Type) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      __typename
    }
  }
`;
export const listDeletedParty = /* GraphQL */ `
  query ListDeletedParty($Type: String!) {
    listDeletedParty(Type: $Type) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      relatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      __typename
    }
  }
`;
export const listDeletedItem = /* GraphQL */ `
  query ListDeletedItem($Type: String!) {
    listDeletedItem(Type: $Type) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      Description
      __typename
    }
  }
`;
export const listDeletedAccountGroups = /* GraphQL */ `
  query ListDeletedAccountGroups {
    listDeletedAccountGroups {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listDeletedAccounts = /* GraphQL */ `
  query ListDeletedAccounts {
    listDeletedAccounts {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const listDeletedCrDrNoteMaster = /* GraphQL */ `
  query ListDeletedCrDrNoteMaster($Type: String!) {
    listDeletedCrDrNoteMaster(Type: $Type) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      OriginalInvoiceNumber
      PaymentStatus
      __typename
    }
  }
`;
export const listlatestInvoice = /* GraphQL */ `
  query ListlatestInvoice {
    listlatestInvoice {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const listlatestPurchase = /* GraphQL */ `
  query ListlatestPurchase {
    listlatestPurchase {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listDeletedTransactionManualJournal = /* GraphQL */ `
  query ListDeletedTransactionManualJournal {
    listDeletedTransactionManualJournal {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      __typename
    }
  }
`;
export const listPOSParties = /* GraphQL */ `
  query ListPOSParties {
    listPOSParties {
      PosPartyID
      CompanyID
      PartyName
      PartyContactNumberID
      LastUpdatedBy
      EnteredTimeStamp
      ExpiredTimeStamp
      RelatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      __typename
    }
  }
`;
export const listLUTBondMaster = /* GraphQL */ `
  query ListLUTBondMaster {
    listLUTBondMaster {
      ID
      LUTNo
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ValidFrom
      ValidTo
      FinancialYearID
      __typename
    }
  }
`;
export const listInvoiceSettings = /* GraphQL */ `
  query ListInvoiceSettings($Type: String!) {
    listInvoiceSettings(Type: $Type) {
      InvoiceSettingsID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      TypeCD
      InvoiceHeading
      SignatureText
      DeclarationAtFooter
      TermsAndCondition
      DeclarationAtFooterFlag
      TermsAndConditionsFlag
      CompanyName
      CompanyCIN
      InvoiceNumber
      CompanyAddress
      CompanyLogo
      InvoiceDate
      CompanyContactNumber
      CompanyEmail
      PaymentMode
      CompanyGSTIN
      CompanyWebsite
      CreditPeriod
      CompanyPAN
      CompanyBankDetails
      PaymentDueDate
      CustomerLegalName
      CustomerGSTIN
      LUTBondDetails
      CustomerDisplayName
      PlaceOfSupply
      DispatchDetails
      CustomerBillingAddress
      CustomerContactPerson
      CustomerContactNumber
      CustomerName
      EWayBillDetails
      CustomerShippingAddress
      CustomerOrderNoAndDate
      EInvoiceDetails
      ItemWiseDiscount
      HSNSACode
      ShowRoundOff
      HSNSASummaryTable
      InvoiceDescription
      RegularInvoiceSignatureFileName
      LastUpdatedBy
      StatusCode
      StatusMessage
      PosInvoiceSignatureFileName
      DefaultSetting
      BankDetails
      UPI_ID
      __typename
    }
  }
`;
export const getBusinessOverViewDataGroups = /* GraphQL */ `
  query GetBusinessOverViewDataGroups(
    $businessOverViewInput: BusinessOverViewInputv3!
  ) {
    getBusinessOverViewDataGroups(
      businessOverViewInput: $businessOverViewInput
    ) {
      StartDate
      EndDate
      AccountGroupName
      AccountTypeCD
      GroupBalance
      DataType
      __typename
    }
  }
`;
export const getBusinessOverViewDataGroupsv2 = /* GraphQL */ `
  query GetBusinessOverViewDataGroupsv2(
    $businessOverViewInput: BusinessOverViewInputv3!
  ) {
    getBusinessOverViewDataGroupsv2(
      businessOverViewInput: $businessOverViewInput
    ) {
      StartDate
      EndDate
      OpeningStock
      ClosingStock
      Sales
      TradePayables
      TradeReceivables
      CurrentAssets
      CurrentLiabilities
      CashAccounts
      BankAccounts
      Purchases
      TradingIncomes
      TradingExpense
      DirectIncome
      DirectExpense
      InDirectIncome
      InDirectExpense
      DataType
      __typename
    }
  }
`;
export const getBusinessOverViewDataGroupSpecific = /* GraphQL */ `
  query GetBusinessOverViewDataGroupSpecific(
    $businessOverViewInput: BusinessOverViewInputGroupSpecific!
  ) {
    getBusinessOverViewDataGroupSpecific(
      businessOverViewInput: $businessOverViewInput
    ) {
      StartDate
      EndDate
      AccountGroupName
      AccountTypeCD
      GroupBalance
      DataType
      __typename
    }
  }
`;
export const getBusinessOverViewDataPandL = /* GraphQL */ `
  query GetBusinessOverViewDataPandL(
    $businessOverViewInput: BusinessOverViewInputv3!
  ) {
    getBusinessOverViewDataPandL(
      businessOverViewInput: $businessOverViewInput
    ) {
      StartDate
      EndDate
      AccountGroupName
      AccountTypeCD
      GroupBalance
      DataType
      __typename
    }
  }
`;
export const getBusinessOverViewDataTopExpenses = /* GraphQL */ `
  query GetBusinessOverViewDataTopExpenses(
    $businessOverViewInput: BusinessOverViewInputv3!
  ) {
    getBusinessOverViewDataTopExpenses(
      businessOverViewInput: $businessOverViewInput
    ) {
      StartDate
      EndDate
      AccountGroupName
      AccountTypeCD
      GroupBalance
      DataType
      __typename
    }
  }
`;
export const listaccountsubgroups = /* GraphQL */ `
  query Listaccountsubgroups($AccountGroupID: Int) {
    listaccountsubgroups(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const listCompanyDocuments = /* GraphQL */ `
  query ListCompanyDocuments($DocumentType: String!, $PartyID: Int!) {
    listCompanyDocuments(DocumentType: $DocumentType, PartyID: $PartyID) {
      ID
      CompanyID
      PartyID
      DocumentType
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      LastUpdatedBy
      IsActive
      Type
      DocumentName
      __typename
    }
  }
`;
export const listClosingStocks = /* GraphQL */ `
  query ListClosingStocks {
    listClosingStocks {
      CompanyID
      CompanyBranchID
      Date
      ClosingBalance
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const listUserCompanies = /* GraphQL */ `
  query ListUserCompanies {
    listUserCompanies {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      DeletionTime
      __typename
    }
  }
`;
export const listPlaceOfSupply = /* GraphQL */ `
  query ListPlaceOfSupply {
    listPlaceOfSupply {
      ID
      StateName
      StateCode
      EnteredTimeStamp
      ExpiredTimeStamp
      IsActive
      __typename
    }
  }
`;
export const getCognitoUserSessions = /* GraphQL */ `
  query GetCognitoUserSessions {
    getCognitoUserSessions {
      SessionID
      CognitoUsername
      LoginTimestamp
      LogoutTimestamp
      LinkedSessionID
      __typename
    }
  }
`;
export const listaccountbalances = /* GraphQL */ `
  query Listaccountbalances {
    listaccountbalances {
      AccountID
      AccountBalance
      ActualBalance
      __typename
    }
  }
`;
export const listspecificaccountbalance = /* GraphQL */ `
  query Listspecificaccountbalance($AccountID: String!) {
    listspecificaccountbalance(AccountID: $AccountID) {
      AccountID
      AccountBalance
      ActualBalance
      __typename
    }
  }
`;
export const listaccountopeningbalancev2 = /* GraphQL */ `
  query Listaccountopeningbalancev2 {
    listaccountopeningbalancev2 {
      AccountsID
      AccountName
      AccountTypeCD
      DisplayOrderNumber
      Path
      AccountGroupID
      AccountGroupName
      AccountParentGroupID
      CompanyID
      FinancialYearID
      CreditAmount
      DebitAmount
      EnteredTimeStamp
      Restrictedflag
      __typename
    }
  }
`;
export const procedurecalltest = /* GraphQL */ `
  query Procedurecalltest {
    procedurecalltest {
      Data
      __typename
    }
  }
`;
export const getReceiptDetails = /* GraphQL */ `
  query GetReceiptDetails($TransactionID: Int, $FinancialYearID: Int) {
    getReceiptDetails(
      TransactionID: $TransactionID
      FinancialYearID: $FinancialYearID
    ) {
      ID
      TransactionID
      CompanyID
      FinancialYearID
      LastUpdatedBy
      EnteredTimeStamp
      ExpiredTimeStamp
      TAN
      PartyName
      __typename
    }
  }
`;
export const listBalancesheetProfitAndLoss = /* GraphQL */ `
  query ListBalancesheetProfitAndLoss($StartDate: Int, $EndDate: Int) {
    listBalancesheetProfitAndLoss(StartDate: $StartDate, EndDate: $EndDate) {
      OpeningCreditAmount
      OpeningDebitAmount
      OpeningBalanceAmount
      NetProfit
      NetLoss
      __typename
    }
  }
`;
export const listBusinessType = /* GraphQL */ `
  query ListBusinessType {
    listBusinessType {
      BusinessTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      BusinessType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const listIndustryType = /* GraphQL */ `
  query ListIndustryType {
    listIndustryType {
      IndustryTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      IndustryType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const listitemtablepreference = /* GraphQL */ `
  query Listitemtablepreference {
    listitemtablepreference {
      ID
      CompanyID
      Type
      ItemCode
      ItemName
      Category
      Unit
      ShowItemIn
      PurchaseAC
      SalesAC
      HSNSAC
      Taxability
      PurchaseAmount
      SellingPrice
      UpdatePrice
      TotalSellingPrice
      EffectiveFrom
      EffectiveTo
      Actions
      UserID
      __typename
    }
  }
`;
export const listPartyInvoicePurchases = /* GraphQL */ `
  query ListPartyInvoicePurchases($AccountID: Int) {
    listPartyInvoicePurchases(AccountID: $AccountID) {
      PartyID
      CompanyID
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      InvoiceID
      InvoiceTypeCD
      InvoicePaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      InvoiceCreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      InvoiceExchangeRate
      InvoiceComments
      ReceivedAmount
      InvoiceAdjustmentAmount
      InvoicePlaceOfSupply
      InvoiceBalanceDueAmount
      InvoiceReverseChargeFlag
      InvoiceTCSApplicableFlag
      InvoiceLastUpdatedBy
      InvoiceStatusCode
      InvoiceStatusMessage
      InvoiceCancelFlag
      ConsigneeName
      ConsigneeGSTIN
      InvoiceCompanyState
      CancelRemark
      DeleteRemark
      InvoiceRoundOffAmount
      InvoiceDiscountType
      InvoiceDiscountValue
      InvoiceSerialNumber
      InvoiceCurrencyCode
      InvoiceCurrencyRate
      InvoicePartyDisplayName
      InvoicePartyLegalName
      InvoicePartyAccountID
      PurchaseID
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      PurchaseCreditDuration
      PurchasePaymentAccountID
      PurchaseComments
      TDSApplicableFlag
      GrantTotalAmount
      PurchaseBalanceDueAmount
      PaymentClearedFlag
      PurchasePlaceOfSupply
      PurchaseCompanyState
      PurchaseLastUpdatedBy
      PurchaseCancelFlag
      PurchaseRoundOffAmount
      PurchaseDiscountType
      PurchaseDiscountValue
      PurchaseAdjustmentAmount
      PurchaseStatusCode
      PurchaseStatusMessage
      PurchaseSerialNumber
      PurchaseCurrencyCode
      PurchaseCurrencyRate
      PurchasePartyDisplayName
      PurchasePartyLegalName
      PurchasePartyAccountID
      PurchaseReverseChargeFlag
      CrDrNoteID
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      CrDrInvoiceTypeCD
      CrDrGSTTypeCD
      CrDrPartyID
      CrDrDeliveryAddressID
      CrDrPaymentType
      CrDrGrandTotalAmount
      CrDrTransactionID
      CrDrUserID
      CrDrCreditDuration
      CrDrPSFlag
      CrDrReverseChargeFlag
      CrDrBalanceDueAmount
      CrDrConsigneeName
      CrDrConsigneeGSTIN
      CrDrPlaceOfSupply
      CrDrCancelFlag
      CrDrCancelRemark
      CrDrRoundOffAmount
      CrDrDiscountType
      CrDrDiscountValue
      CrDrAdjustmentAmount
      CrDrSerialNumber
      CrDrCurrencyCode
      CrDrCurrencyRate
      CrDrOriginalInvoiceNumber
      CrDrPaymentStatus
      __typename
    }
  }
`;
export const listAccountTransactionDetailsv2 = /* GraphQL */ `
  query ListAccountTransactionDetailsv2($AccountID: Int!) {
    listAccountTransactionDetailsv2(AccountID: $AccountID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      LastUpdatedBy
      FinancialYearID
      StatusCode
      StatusMessage
      TransactionMasterTypeCD
      VoucherNumber
      __typename
    }
  }
`;
export const listAccountTransactionDetailsv3 = /* GraphQL */ `
  query ListAccountTransactionDetailsv3(
    $AccountID: Int!
    $StartDate: AWSTimestamp!
    $EndDate: AWSTimestamp!
  ) {
    listAccountTransactionDetailsv3(
      AccountID: $AccountID
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      EnteredTimeStamp
      FinancialYearID
      InvoiceID
      PurchaseID
      CrDrNoteID
      VoucherType
      VoucherNumber
      AccountID
      AccountName
      AccountTypeCD
      AccountGroupName
      TransactionType
      EntryOrderNumber
      TotalDebitAmount
      TotalCreditAmount
      Balance
      OppositeAccountID
      OppositeAccountName
      Comments
      __typename
    }
  }
`;
export const getRelatedPaymentDetails = /* GraphQL */ `
  query GetRelatedPaymentDetails($InvoiceType: String!, $ID: Int) {
    getRelatedPaymentDetails(InvoiceType: $InvoiceType, ID: $ID) {
      ID
      SerialNumber
      PaymentTransactionID
      PaymentVoucherNumber
      TransactionTypeCD
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getOTPDetails = /* GraphQL */ `
  query GetOTPDetails {
    getOTPDetails {
      ID
      Purpose
      OTPCode
      EnteredTimeStamp
      Active
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listItemLotDetails = /* GraphQL */ `
  query ListItemLotDetails {
    listItemLotDetails {
      LotID
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LotNumber
      LotQuantity
      ItemRate
      TypeCD
      Balance
      __typename
    }
  }
`;
export const checkItemUsed = /* GraphQL */ `
  query CheckItemUsed($ItemID: Int) {
    checkItemUsed(ItemID: $ItemID) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const getItemClosingStock = /* GraphQL */ `
  query GetItemClosingStock($Date: Int!) {
    getItemClosingStock(Date: $Date) {
      ItemID
      ItemCode
      ItemName
      LotID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LotNumber
      LotQuantity
      ItemRate
      TypeCD
      Balance
      OpeningStock
      OpeningStockRate
      InStock
      InStockRate
      OutStock
      OutStockRate
      ClosingStock
      ClosingStockRate
      __typename
    }
  }
`;
export const listLineItems = /* GraphQL */ `
  query ListLineItems($JSONData: AWSJSON!) {
    listLineItems(JSONData: $JSONData) {
      Type
      InvoiceID
      PurchaseID
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      LineItemNumber
      InvoiceLineItemType
      HSNSACCode
      Taxability
      PriceType
      LotID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      VoucherNumber
      InvoiceLineTypeCD
      Comments
      BalanceDueAmount
      ReverseChargeFlag
      CancelFlag
      InvoiceItemID
      PurchaseItemID
      GSTRate
      GSTAmount
      CessAmount
      ItemQuantity
      HSNCode
      ItemName
      SalesAccountID
      PurchaseAccountID
      HSNDescription
      ItemCode
      HSNSACID
      HSNCodeType
      HSNMasterCode
      __typename
    }
  }
`;
export const getItemWiseClosingStock = /* GraphQL */ `
  query GetItemWiseClosingStock($Date: Int!, $ItemID: Int) {
    getItemWiseClosingStock(Date: $Date, ItemID: $ItemID) {
      ItemID
      ItemCode
      ItemName
      LotID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LotNumber
      LotQuantity
      ItemRate
      TypeCD
      Balance
      OpeningStock
      OpeningStockRate
      InStock
      InStockRate
      OutStock
      OutStockRate
      ClosingStock
      ClosingStockRate
      __typename
    }
  }
`;
export const getPartyInvoices = /* GraphQL */ `
  query GetPartyInvoices($PartyID: Int!, $PartyTypeCD: String!) {
    getPartyInvoices(PartyID: $PartyID, PartyTypeCD: $PartyTypeCD) {
      InvoiceID
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PurchaseGSTTypeCD
      PartyID
      SupplierID
      PaymentAccountID
      InvoiceDate
      EntryDate
      InvoiceNumber
      VoucherNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      GrantTotalAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      SupplierAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      PaymentTypeCD
      ExchangeRate
      CurrencyRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      LastUpdatedBy
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      TCSApplicableFlag
      TDSApplicableFlag
      CompanyState
      CancelRemark
      DeleteRemark
      FinancialYearID
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      PaymentClearedFlag
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const listPriceType = /* GraphQL */ `
  query ListPriceType {
    listPriceType {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PriceType
      UserID
      Is_Default
      Is_Active
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const listeInvoiceUsers = /* GraphQL */ `
  query ListeInvoiceUsers {
    listeInvoiceUsers {
      ID
      CompanyID
      UserName
      Password
      EnteredTimeStamp
      ExpiredTimeStamp
      Is_Active
      __typename
    }
  }
`;
export const geteInvoiceMaster = /* GraphQL */ `
  query GeteInvoiceMaster($InvoiceID: Int!) {
    geteInvoiceMaster(InvoiceID: $InvoiceID) {
      ID
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AckNo
      AckDt
      Irn
      SignedQRCode
      UserID
      is_cancelled
      __typename
    }
  }
`;
export const getAccountDashboardBalances = /* GraphQL */ `
  query GetAccountDashboardBalances(
    $CompanyID: Int!
    $StartDate: AWSTimestamp!
    $EndDate: AWSTimestamp!
  ) {
    getAccountDashboardBalances(
      CompanyID: $CompanyID
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      CompanyID
      FinancialYearID
      AccountName
      AccountID
      BASE_LEVEL
      level_id
      AccountGroupName
      act_group
      AccountBalance
      __typename
    }
  }
`;
export const getLinkedReceipts = /* GraphQL */ `
  query GetLinkedReceipts($VoucherNumber: String!) {
    getLinkedReceipts(VoucherNumber: $VoucherNumber) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      LinkedAmount
      InvoiceNumber
      InvoiceDate
      ReceiptVoucherNumber
      GrandTotalAmount
      BalanceDueAmount
      __typename
    }
  }
`;
export const getTodo = /* GraphQL */ `
  query GetTodo($id: ID!) {
    getTodo(id: $id) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTodos = /* GraphQL */ `
  query ListTodos(
    $filter: ModelTodoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTodos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
